import { jsx as t, jsxs as n } from "react/jsx-runtime";
import c from "react";
import m from "./index.es2352.js";
import { BodyText as p } from "./index.es487.js";
const s = ({ disabled: r }) => /* @__PURE__ */ t("svg", { width: "3", height: "4", viewBox: "0 0 3 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ t("circle", { cx: "1.5", cy: "2", r: "1.5", fill: "var(--plac-text-gray)", opacity: r ? 0.3 : 1 }) }), x = ({ bullets: r, disabled: i, testId: e = "bullets-component" }) => {
  const a = i ? "disabled" : "gray";
  return r != null && r.length ? /* @__PURE__ */ t("div", { className: m.bullets, "data-pl-identifier": "bullets", "data-testid": e, children: r == null ? void 0 : r.map((l, o) => /* @__PURE__ */ n(c.Fragment, { children: [
    o !== 0 && /* @__PURE__ */ t(s, { disabled: i }),
    /* @__PURE__ */ t(p, { isEllipsis: !0, size: "small", color: a, children: l })
  ] }, o)) }) : null;
};
export {
  s as BulletSeparator,
  x as Bullets
};
//# sourceMappingURL=index.es497.js.map
